import ChevronLeft from 'apollo-react-icons/ChevronLeft';
import { useNavigate, useLocation } from "react-router-dom";
import { adminRoutesConfig, superAdminRoutesConfig, customerRoutesConfig } from "../../routesConfig";

const TitleHeader = (props) => {
    const { title, style, icon } = props;
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const requestName = searchParams.get('request_name');
    const draftId = searchParams.get('draftId');

    // Helper to get persona config based on path
    const getPersonaConfig = (pathname) => {
        if (pathname.startsWith("/admin")) return adminRoutesConfig;
        if (pathname.startsWith("/super-admin")) return superAdminRoutesConfig;
        if (pathname.startsWith("/customer")) return customerRoutesConfig;
        return [];
    };

    // Helper to find parent route
    const getParentRoute = (pathname) => {
        const routes = getPersonaConfig(pathname);
        const segments = pathname.split("/").filter(Boolean);
        
        if (pathname.startsWith("/customer/progress/")) {
            return "/customer/requests/my-requests";
        }
        
        if (pathname.startsWith("/customer/requests/new-requests/view/") && draftId) {
            return "/customer/requests/my-requests";
        }
        
        if (pathname.match(/\/(admin|super-admin)\/workflows\/\d+\/versions\/\d+\/view$/)) {
            const workflowId = pathname.match(/\/workflows\/(\d+)\//)[1];
            const persona = pathname.startsWith("/admin") ? "admin" : "super-admin";
            return `/${persona}/workflows/${workflowId}/versions`;
        }
        
        // Remove last segment and try to match
        for (let i = segments.length - 1; i > 0; i--) {
            const parentPath = "/" + segments.slice(0, i).join("/");
            if (routes.some(route => {
                // Replace :params with regex wildcards
                const routePattern = route.path.replace(/:[^/]+/g, "[^/]+");
                const regex = new RegExp(`^${routePattern}$`);
                return regex.test(parentPath);
            })) {
                return parentPath;
            }
        }
        // Fallback to persona home
        if (pathname.startsWith("/admin")) return "/admin";
        if (pathname.startsWith("/super-admin")) return "/super-admin";
        if (pathname.startsWith("/customer")) return "/customer/home";
        return "/";
    };

    return (
        <>
        <div style={{...style,
        height: '98px', marginBottom: '20px',
        border: '1px solid #E9E9E9', borderRadius: '5px',
        padding: '24px 24px 24px 20px', display: 'flex', alignItems: 'center'}}>
            <div style={{height: "100%", display: 'flex', alignItems: 'center', cursor: 'pointer'}}
            onClick={() => {
                const parent = getParentRoute(location.pathname);
                const tabIndex = location.state?.tabIndex;
                if (typeof tabIndex === "number") {
                  localStorage.setItem("approvals_activeTab", tabIndex);
                }
                
                if (parent === "/customer/requests/my-requests" && draftId) {
                  localStorage.setItem("customer_requests_activeTab", 4);
                }
              
                navigate(parent);
            }}>
                <ChevronLeft style={{color: '#0768FD', width: '0.5em', height: '0.5em', marginRight: '20px'}}/>
            </div>
            <div style={{fontSize:'26px', borderLeft: '1px solid #E9E9E9', paddingLeft: '20px',
                display: 'flex'}}>
                <div style={{marginRight: '20px',display: 'flex',
                    alignItems: 'center'
                }}>
                {icon}
                </div>
                <div className='capitalize' style={{color: '#444444',
                    fontFamily: 'Proxima Nova', display: 'flex',alignItems: 'center',
                    fontWeight: 400, cursor: 'default', userSelect: 'none'}}>
                        {requestName || title}
                </div>
            </div>
        </div>
        </>
    )
}

export default TitleHeader;